import { InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';
import {DocumentIdentifierType, JobType, UserTaxGroup} from '../../../../../../spartacus-custom.module';
export const DOCUMENT_IDENTIFIER_TYPE_NORMALIZER = new InjectionToken<Converter<any, DocumentIdentifierType>>(
  'DocumentIdentifierTypeNormalizer'
);
export const JOB_TYPE_IDENTIFIER_TYPE_NORMALIZER = new InjectionToken<Converter<any, JobType>>(
  'JobTypeNormalizer'
);
export const USER_TAX_GROUP_IDENTIFIER_TYPE_NORMALIZER = new InjectionToken<Converter<any, UserTaxGroup>>(
  'UserTaxGroupNormalizer'
);
